import { TypePolicies } from '@apollo/client'

export const projectManagementTypePolicies: TypePolicies = {
  ProjectManagementGlobalTimeRecord: {
    keyFields: ['customId', 'isFlexible'],
  },
}
